import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule,FormsModule, Validators } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { LoanChecklistModel } from '../../core/models/loan-checklist.model';
import { LmsModalFrameComponent } from '../../shared/ui/lms-modal-frame/lms-modal-frame.component';
import { AppUtilityService } from 'src/app/app-utility.service';

@Component({
  selector: 'app-loan-checklist-dialog',
  templateUrl: './loan-checklist-dialog.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, LmsModalFrameComponent],
})
export class LoanChecklistDialogComponent {
  checklistItems: {
    key: keyof LoanChecklistModel;
    label: string;
    checked: boolean;
  }[] = [
    {
      key: 'termsAndConditionsExplained',
      label: 'Terms and conditions explained to client.',
      checked: false,
    },
    {
      key: 'barcodedIdUploaded',
      label: "Client's Barcoded ID supplied and uploaded.",
      checked: false,
    },
    {
      key: 'debicheckSlipUploaded',
      label: 'Debicheck slip uploaded on LMS.',
      checked: false,
    },
    {
      key: 'accountNumbersMatch',
      label:
        'The account number on the Debicheck slip corresponds with the account number on the salary advice and bank statement.',
      checked: false,
    },
    {
      key: 'myBenefitsTermsAccepted',
      label: 'I accept the terms and conditions of the MyBenefits product.',
      checked: false,
    },
    {
      key: 'annexureAReceived',
      label:
        'I have received the Annexure A explaining the MyBenefits product.',
      checked: false,
    },
  ];

  reasonForFirstLoanC = new FormControl(null, [Validators.required, Validators.max(250)]);
  reasonForSecondLoanC = new FormControl(null, [Validators.required, Validators.max(250)]);
  isFirstLoanOfTheDay = true;
  isFirstLoan = true;

  isMultipleRequired = false;
  get allChecked(): boolean {
    return this.checklistItems.every((item) => item.checked) && (this.isMultipleRequired ? this.reasonForFirstLoan?.value.trim() !== '' && this.reasonForSecondLoan?.value.trim() !== '' : true);
  }

  constructor(public modalRef: MdbModalRef<LoanChecklistDialogComponent>,
    public global_utility: AppUtilityService) {}

  get reasonForFirstLoan() {
    return this.reasonForFirstLoanC as FormControl;
  }

  get reasonForSecondLoan() {
    return this.reasonForSecondLoanC as FormControl;
  }

  confirm() {
    if (!this.isFirstLoanOfTheDay) {
      if ((this.reasonForFirstLoan?.value || '') == '' || (this.reasonForSecondLoan?.value || '') == '') {
        this.global_utility.warning('Please provide reasons for current loan.');
        return;
      }
    }
    const result = new LoanChecklistModel();
    for (const item of this.checklistItems) {
      (result as any)[item.key] = item.checked;
    }
    if(!this.isFirstLoanOfTheDay) {
      result.reasonForFirstLoan = this.reasonForFirstLoan?.value || '';
      result.reasonForSecondLoan = this.reasonForSecondLoan?.value ?? '';
    }
    this.modalRef.close(result);
  }

  cancel() {
    this.modalRef.close(null);
  }

  get isAllChecked(): boolean {
    return this.checklistItems.every((item) => item.checked);
  }


  get hasCorrectReason(): boolean {
    if(!this.isFirstLoanOfTheDay) {
      return !this.reasonForFirstLoan?.invalid && !this.reasonForSecondLoan?.invalid && !this.reasonForFirstLoan?.value && !this.reasonForSecondLoan?.value;
    }

    return true;
  }
}

export interface LoanChecklistItem {
  label: string;
  checked: boolean;
}
